export const shippingMethods = `chosenShippingMethods
    availableShippingMethods {
      rates {
        cost
        id
        label
        methodId
      }
    }`;
